/**
 * V2 Navigation – uses NavListV2 with portal for sub-nav popup; scroll on inner wrapper (nav stays overflow:visible).
 */
import React, { useState, useRef, useMemo, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import IconUser from "../../../assets/images/IconUser";
import { Wrapper, Nav } from "../../../components/Navigation/style";
import logo from "../../../assets/images/logo.png";
import { Icon } from "../../../components/styledConstants";
import NavListV2 from "./NavListV2";
import { navDataV2 } from "./navDataV2";
import { userLogout } from "../../../utils/common";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../store/actions/user";
import { setAlert } from "../../../store/actions/alert";
import { usePermissionsFromJWT } from "../../../utils/DecodeJwt";
import { useSessionExpiryChecker } from "../../../utils/DecodeJwt";
// import ExperienceToggleSwitch from "../../../shell/ExperienceToggleSwitch";

export default function NavigationV2() {
  const navigate = useNavigate();
  const [navigationData, setNavigationData] = useState([]);
  const [loading, setLoading] = useState(true);
  const filteredNavRef = useRef([]);
  const refNav = useRef(null);
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.user);
  const { permissions: userPermissions } = usePermissionsFromJWT();
  const auth = sessionStorage.getItem("authToken");

  useSessionExpiryChecker(auth, () => {
    dispatch(setAlert({ message: "Your session has been expired", status: "info", timeout: 5000 }));
    logoutUser();
  });

  const hasPermission = (item, permissions) => {
    if (item.alwaysShow) return true;
    return !item.permissions || item.permissions.some((p) => permissions.includes(p));
  };

  const filteredNav = useMemo(() => {
    if (!userPermissions || !Array.isArray(userPermissions)) return [];
    return navDataV2
      .map((item) => {
        if (!hasPermission(item, userPermissions)) return null;
        if (item.subNav && Array.isArray(item.subNav)) {
          const filteredSubNav = item.subNav.filter((sub) => hasPermission(sub, userPermissions));
          // Hide parent only when it had children but all were filtered out
          if (item.subNav.length > 0 && filteredSubNav.length === 0) return null;
          return { ...item, subNav: filteredSubNav };
        }
        return item;
      })
      .filter(Boolean)
      .map((item) => ({ ...item, expanded: false }));
  }, [userPermissions]);

  useEffect(() => {
    filteredNavRef.current = filteredNav;
    setNavigationData(
      filteredNav.map((item) => ({
        ...item,
        expanded: false,
      }))
    );
    setLoading(false);
  }, [filteredNav]);

  const toggleNavigation = (e, isExpanded, index) => {
    e.preventDefault();
    const updated = navigationData.map((item, i) => ({
      ...item,
      expanded: i === index ? !isExpanded : false,
    }));
    setNavigationData(updated);
  };

  const hideSubmenu = () => {
    if (!Array.isArray(filteredNavRef.current)) return;
    const updated = filteredNavRef.current.map((item) => ({ ...item, expanded: false }));
    setNavigationData(updated);
  };

  const handleClickOutside = (e) => {
    if (refNav.current && !refNav.current.contains(e.target)) {
      const popup = document.querySelector('[data-v2-subnav-popup]');
      if (!popup || !popup.contains(e.target)) {
        hideSubmenu();
      }
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => document.removeEventListener("click", handleClickOutside, true);
  }, []);

  const logoutUser = () => {
    userLogout();
    dispatch(logout());
    navigate("/");
  };

  const goProfile = () => navigate("/profile");

  if (loading) {
    return (
      <Wrapper>
        <div className="loading-spinner">Loading navigation...</div>
      </Wrapper>
    );
  }

  return (
    <Wrapper ref={refNav}>
      <Link className="logo" to="/welcome">
        <Icon src={logo} width="141px" alt="" />
      </Link>
      <div className="user-info form-item ">
        <div className="has-value item-select css-b62m3t-container">
          <div className="select__control css-1s2u09g-control">
            <p className="item-label-wrapper item">
              <span className="item-icon">
                <IconUser />
              </span>
              {user?.firstName} {user?.lastName}
            </p>
          </div>
        </div>
        <div className="user-logout-box">
          <button className="mt4 user-logout">
            <p onClick={goProfile}>PROFILE</p>
            <p onClick={logoutUser}>LOG OUT</p>
          </button>
        </div>
      </div>

      {/* <div className="nav-v2-toggle">
        <ExperienceToggleSwitch />
      </div> */}

      <Nav className="nav-v2">
        <div className="nav-scroll-area">
          <NavListV2
            navData={navigationData}
            toggleNavigation={toggleNavigation}
            hideSubmenu={hideSubmenu}
            className="navlist"
          />
        </div>
      </Nav>
    </Wrapper>
  );
}
